var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1d2b02ea-2641-426f-babb-6ec1f3b61e3d",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-6a4f16e9-7d2c-4d63-9ed6-c7efcc38ae46{fill:#fff;}.uuid-7f07f466-e240-409f-adae-072fd11741e6{fill:#233f90;}.uuid-d8a73c64-1268-4347-9666-f98e37ea7b83{fill:#00b7b0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6a4f16e9-7d2c-4d63-9ed6-c7efcc38ae46",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-bdce5187-1582-4f28-aecd-74e21b0dc543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-71ee6ee0-90b4-453e-a127-6e48dd836091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-6ba07ec0-b28d-47a2-91b9-1dc7142abade"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-10d7354f-9d8f-4b23-bc48-230bf665a679",
    className: "uuid-7f07f466-e240-409f-adae-072fd11741e6",
    d: "m161.28,322.24v54.63h189.43v-37.53h-142.56v-62.05l-46.87,44.95Zm0-187.11v49.02l46.94,44.86v-56.25h137.51v-37.62h-184.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-9b290e91-9b46-4358-b4b8-1c2a94c86c13",
    className: "uuid-d8a73c64-1268-4347-9666-f98e37ea7b83",
    d: "m215.11,235.51l18.36,17.64-20.26,19.35h116.97v-36.99h-115.07Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEeft);
export default __webpack_public_path__ + "static/media/icon_eeft.65dba59227d306f03789ddec69acdc87.svg";
export { ForwardRef as ReactComponent };